import { TermsOfServiceComponent } from './terms-of-service.component';

export { TermsOfServiceComponent };
